<script>
/**
 * ****************************************************************************
 * @description     :   Input Radio Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of input radio component
 */
var FcRadioButton = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        value: String | Number,
        modelValue: String | Number,
        isDisabled: Boolean,
        isRequired: Boolean,
        isMobile: {
            type: Boolean,
            default: false
        },
        options: Array,
        onChange: Function
    },
    emits: ['update:modelValue'],
    computed: {
        vewValue() {
            return this.modelValue != null && this.modelValue != undefined
                ? this.modelValue
                : this.value;
        }
    },
    methods: {
        /**
         * select item and checked input radio
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params : value
         * @access : private
         */
        selectedOption(val) {
            return this.vewValue + '' == val + '';
        },
        /**
         * click update item input radio
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params : value
         * @access : private
         */
        updateInput(e) {
            const vewValue = e.target.value;
            this.$emit('update:modelValue', vewValue);
            if (this.onChange) {
                this.onChange(e, vewValue);
            }
        }
    }
};
export default FcRadioButton;
</script>
